import { saveBlob } from "../../lib/saveBlob";

const cell = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;

// Excel عبر CSV (بادئة BOM لدعم العربية في Excel). يعمل على الويب والجوال عبر saveBlob.
export const exportHistoryCsv = async (rows, headers, fileName) => {
  const head = headers.map((h) => cell(h.label)).join(",");
  const body = rows.map((r) => headers.map((h) => cell(r[h.key])).join(",")).join("\n");
  const csv = `\uFEFF${head}\n${body}`;
  await saveBlob(new Blob([csv], { type: "text/csv;charset=utf-8" }), fileName);
};
